/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IApplyIdFacade {
  windowResize(height: number): void;
  validateApplySelection(): Observable<any>;
  applyIdClick(id: string): void;
  closePopupAction(): void;
}

export const APPLY_ID_FACADE_TOKEN = new InjectionToken<IApplyIdFacade>('APPLY_ID_FACADE_TOKEN');
